import { Box } from '@mui/material';
import { CurveData } from '~/domain/patient/dvh';
import DoseStatisticsTable from '../table-panel/DoseStatisticsTable';

interface DoseStatisticsPaneProps {
    readonly curves: CurveData[];
}

/**
 * The dose statistics table of one dose, filling the box it is given:
 * min, max and mean dose per structure, sortable by column.
 */
export default function DoseStatisticsPane({
    curves,
}: DoseStatisticsPaneProps) {
    return (
        <Box
            data-testid="dose-statistics-pane"
            sx={{ position: 'absolute', inset: 0 }}
        >
            <DoseStatisticsTable dvhCurves={curves} />
        </Box>
    );
}
